import styled from '@emotion/styled'

export const QuestionsList = styled.div<{ isMobile: boolean }>`
  max-height: 1000px;
  overflow-y: auto;
  width: 70%;
  margin-top: 20px;
  color: #3c3043;
  max-width: 810px;

  @media (max-width: 1000px) {
    width: 80%;
  }

  @media (max-width: 576px) {
    width: 100%;
  }
`

export const QuestionItem = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 25px;
  margin: 10px 0;
  border-bottom: 5px solid #def;
`

export const QuestionText = styled.p`
  font-family: 'Milliard Bold';
  font-size: 1.5rem;

  @media (max-width: 1000px) {
    font-size: 1.25rem;
  }

  i {
    font-style: italic;
  }
`

export const AnswerText = styled.p`
  font-family: 'Milliard Book';
  font-size: 1.25rem;
  margin-top: 10px !important;

  @media (max-width: 1000px) {
    font-size: 1rem;
  }

  i {
    font-style: italic;
  }
`
